export default __webpack_public_path__ + "static/media/Group 7.5a1eb28f.png";